class UrlUtils {
	constructor() {
		this.resetBaseUrl();
		this.globalPathParams = {};
		this.globalQueryParams = {};
	}

	setBaseUrl(baseUrl) {
		this.baseUrl = baseUrl;
	}

	resetBaseUrl() {
		this.baseUrl = getDefaultBaseUrl();
	}

	addGlobalPathParams(globalPathParams) {
		Object.assign(this.globalPathParams, globalPathParams);
	}

	addGlobalQueryParams(globalQueryParams) {
		Object.assign(this.globalQueryParams, globalQueryParams);
	}

	getUrlObjectFromString(urlString) {
		if (typeof URL === "function") {
			return new URL(urlString);
		}
		else {
			let linkElem = document.createElement("a");
            linkElem.href = urlString;
            return linkElem;
		}
	}

	getUrl(path, pathParams, queryParams) {
		pathParams = Object.assign({}, this.globalPathParams, pathParams)
		queryParams = Object.assign({}, this.globalQueryParams, queryParams);
		for(let key in pathParams){
			let paramReplacementPattern = ':' + key;
			path = path.replace(paramReplacementPattern, pathParams[key]);
		}

		if(queryParams) {
			path = path + '?';
			for(let key in queryParams) {
				path = path + key + '=' + queryParams[key] + '&';
			}
			path = path.substring(0, path.length - 1);
		}

		let baseUrl = this.baseUrl.endsWith('/') ? this.baseUrl.slice(0, this.baseUrl.length -1) : this.baseUrl;
		path = path.startsWith('/') ? path.slice(1) : path;

		return baseUrl + "/" + path;
	}

	isValidUrl(url) {
		const PATTERN = "^(((ftp|http|https|file|www|mailto|callto|(\\[(\\w(\\w|\\s)*)\\])):(\\/\\/|\\/\\/+|(?!\\/)))(\\w+:{0,1}\\w*@)?(\\S+)(:[0-9]+)?(\\/|\\/([\\w#!:.?+=&%@!\\-\\/]))?)";
		var re = new RegExp(PATTERN);
		return re.test(url);
	}


}

function getDefaultBaseUrl() {
	return window.location.origin || window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '');
}


export default new UrlUtils()


// WEBPACK FOOTER //
// ../common/utils/http/url.js